var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publish_home_div"},[_c('MainQuestionPublish',{staticClass:"main_questions"}),_c('Side',{staticClass:"side_questions"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }